import { render } from "./DevicesTable.vue?vue&type=template&id=38f6d735"
import script from "./DevicesTable.vue?vue&type=script&lang=js"
export * from "./DevicesTable.vue?vue&type=script&lang=js"

import exportComponent from "/Users/javiermartin/OneDrive_Sigeen/Sistena/Server_Mio/sistena-admin-gui-main_rev1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__